import React from "react";
import PropTypes from "prop-types";
import Badge from "antd/es/badge";
import Card from "antd/es/card";
import Col from "antd/es/col";
import Divider from "antd/es/divider";
import Row from "antd/es/row";
import DetailsColumn from "./DetailsColumn";

const IdentificationDetails = ({ transactionRecord, historyDrawer }) => {
  const getIdentificationDetails = (currentRecord) => {
    if (
      currentRecord &&
      currentRecord.operationData &&
      currentRecord.operationData.length > 0 &&
      currentRecord.operationData[0].scan_res &&
      currentRecord.operationData[0].scan_res.scan2PMS &&
      currentRecord.operationData[0].scan_res.scan2PMS.SCANNEDINFO
    ) {
      const data = currentRecord.operationData[0].scan_res.scan2PMS.SCANNEDINFO;
      if (historyDrawer) {
        return {
          name: data.tti_fullname || "-",
          documentID: "-",
          expiryDate: "-",
          issueDate: "-",
          address: "-",
          city: "-",
          state: "-",
          country: "-",
          zip: "-",
        };
      }
      return {
        name: data.tti_fullname || "-",
        documentID: data.tti_license || "-",
        expiryDate: data.tti_expirationdate || "-",
        issueDate: data.tti_issuedate || "-",
        address: data.tti_address || "-",
        city: data.tti_city || "-",
        state: data.tti_state || "-",
        country: data.tti_county || "-",
        zip: data.tti_zip || "-",
      };
    }
    return {
      name: "-",
      documentID: "-",
      expiryDate: "-",
      issueDate: "-",
      address: "-",
      city: "-",
      state: "-",
      country: "-",
      zip: "-",
    };
  };

  const identificationDetails = getIdentificationDetails(transactionRecord);

  return (
    <Card style={{ marginTop: "20px", borderColor: "#ffb551" }}>
      <Row type="flex" justify="space-between">
        <Col style={{ paddingTop: "5px" }}>
          <Badge count={"Identification Details"} className="details-badge" />
        </Col>
      </Row>

      <div className="left-margin">
        <Row>
          <DetailsColumn label={"Name"} value={identificationDetails.name} />
        </Row>
      </div>

      <Divider />

      <div className="left-margin">
        <Row>
          <DetailsColumn
            label={"Document ID"}
            value={identificationDetails.documentID}
          />

          <DetailsColumn
            label={"Expiry Date"}
            value={identificationDetails.expiryDate}
          />

          <DetailsColumn
            label={"Issue Date"}
            value={identificationDetails.issueDate}
          />
        </Row>
      </div>

      <Divider />

      <div className="left-margin">
        <Row>
          <DetailsColumn
            label={"Address"}
            value={identificationDetails.address}
          />

          <DetailsColumn label={"City"} value={identificationDetails.city} />

          <DetailsColumn
            label={"State"}
            value={identificationDetails.state}
          />
        </Row>
      </div>

      <Divider />

      <div className="left-margin">
        <Row>
          <DetailsColumn
            label={"Country"}
            value={identificationDetails.country}
          />

          <DetailsColumn
            label={"ZIP code"}
            value={identificationDetails.zip}
          />
        </Row>
      </div>
    </Card>
  );
};


IdentificationDetails.defaultProps = {
  transactionRecord: {},
};

export default IdentificationDetails;
